import { useState } from "react";
import { Header } from "../../../common/Header/Header.jsx";
import { AlarmTimesParametersSection } from "./AlarmTimesParametersSection.jsx";
import { ServScalePriceParametersSection } from "./ServScalePriceParametersSection.jsx";
import { OperationsCommissionParametersSection } from "./OperationsCommissionParametersSection.jsx";
import "./Parameters.scss";

export const Parameters = () => {
  const [openAlarmTimes, setOpenAlarmTimes] = useState(false);
  const [openServScale, setOpenServScale] = useState(false);
  const [openCommission, setOpenCommission] = useState(false);

  return (
    <>
      <Header />
      <div className="service-with-container container parameters-page">
        <h1 className="title-component parameters-page__title">Parámetros</h1>
        <div className="parameters-page__breadcrumb">
          TUGRUERO / CONFIGURACIÓN / PARÁMETROS / OPERACIONES
        </div>

        <section className="parameters-accordion">
          <button
            type="button"
            className="parameters-accordion__header"
            onClick={() => setOpenAlarmTimes((o) => !o)}
            aria-expanded={openAlarmTimes}
          >
            <span>Tiempos de gestión de alarmas por estatus</span>
            <span
              className={`parameters-accordion__chevron ${openAlarmTimes ? "parameters-accordion__chevron--open" : ""
                }`}
            />
          </button>
          {openAlarmTimes && (
            <div className="parameters-accordion__body">
              <AlarmTimesParametersSection />
            </div>
          )}
        </section>

        <section className="parameters-accordion parameters-accordion--spaced">
          <button
            type="button"
            className="parameters-accordion__header"
            onClick={() => setOpenServScale((o) => !o)}
            aria-expanded={openServScale}
          >
            <span>Variables de baremo</span>
            <span
              className={`parameters-accordion__chevron ${openServScale ? "parameters-accordion__chevron--open" : ""
                }`}
            />
          </button>
          {openServScale && (
            <div className="parameters-accordion__body">
              <ServScalePriceParametersSection />
            </div>
          )}
        </section>

        <section className="parameters-accordion parameters-accordion--spaced">
          <button
            type="button"
            className="parameters-accordion__header"
            onClick={() => setOpenCommission((o) => !o)}
            aria-expanded={openCommission}
          >
            <span>Costo de comisiones</span>
            <span
              className={`parameters-accordion__chevron ${
                openCommission ? "parameters-accordion__chevron--open" : ""
              }`}
            />
          </button>
          {openCommission && (
            <div className="parameters-accordion__body">
              <OperationsCommissionParametersSection />
            </div>
          )}
        </section>
      </div>
    </>
  );
};
